export const getUniqueStrings = (arr) => arr.reduce((acc, item) => acc.includes(item) ? acc : [...acc, item], []);
